import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-mass-media',
  templateUrl: './access-mass-media.component.html',
  styleUrls: ['./access-mass-media.component.scss']
})
export class AccessMassMediaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
